export default __webpack_public_path__ + "static/media/Idle (4).13990507.png";